var map = {
	"./banner/dois.png": 1085,
	"./banner/dois.svg": 9327,
	"./banner/doisMobile.png": 2855,
	"./banner/doisMobile.svg": 8549,
	"./banner/quatro.png": 5718,
	"./banner/quatro.svg": 8996,
	"./banner/quatroMobile.png": 8144,
	"./banner/quatroMobile.svg": 3578,
	"./banner/tres.png": 8696,
	"./banner/tres.svg": 4290,
	"./banner/tresMobile.png": 6546,
	"./banner/tresMobile.svg": 6248,
	"./banner/um.png": 6604,
	"./banner/um.svg": 1438,
	"./banner/umMobile.png": 6454,
	"./banner/umMobile.svg": 5668,
	"./destaques/imageCinco.jpg": 4736,
	"./destaques/imageDois.jpg": 137,
	"./destaques/imageOito.jpg": 9737,
	"./destaques/imageQuatro.jpg": 8742,
	"./destaques/imageSeis.jpg": 9482,
	"./destaques/imageSete.jpg": 1227,
	"./destaques/imageTres.jpg": 3608,
	"./destaques/imageUm.jpg": 7348,
	"./diatechSoc.png": 864,
	"./diatechSoc.svg": 5236,
	"./facebook.svg": 7103,
	"./logoDiatech.svg": 748,
	"./logoDiatechUm.svg": 9950,
	"./logoDiatechUmV1.svg": 2213,
	"./representada/actua.svg": 4312,
	"./representada/bosch.svg": 8475,
	"./representada/comparco.svg": 4040,
	"./representada/gree.svg": 1483,
	"./representada/heliotek.svg": 6423,
	"./representada/kaoDutos.svg": 9570,
	"./representada/mitsubishi.svg": 3683,
	"./representada/trisoft.png": 3705,
	"./representada/ventokit.svg": 6402,
	"./representada/wdb.svg": 2843,
	"./solucoes/acessorios.jpg": 404,
	"./solucoes/acessorios.png": 4208,
	"./solucoes/acessorios2.jpg": 5108,
	"./solucoes/air.svg": 7579,
	"./solucoes/aquecedor_gas_therm_5700.webp": 8087,
	"./solucoes/aquecedor_premium_gas.webp": 8341,
	"./solucoes/aquecimentoGas.png": 3141,
	"./solucoes/aquecimentoGasNovo.png": 2689,
	"./solucoes/aquecimentoPiscina.png": 141,
	"./solucoes/aquecimentoPiscinaSolar.png": 6682,
	"./solucoes/aquecimentoSolarBanho.png": 5413,
	"./solucoes/bombaCalor.jpg": 9735,
	"./solucoes/bomba_calor_cs_2000_p.webp": 5580,
	"./solucoes/bomba_calor_cs_2500_dw.webp": 176,
	"./solucoes/bomba_calor_wavetek.webp": 5537,
	"./solucoes/caldeira.jpg": 9382,
	"./solucoes/climatizacaoComercial.jpg": 681,
	"./solucoes/climatizacaoComercialMulti.jpg": 1770,
	"./solucoes/cold.svg": 1539,
	"./solucoes/coletor_elite.webp": 3446,
	"./solucoes/coletor_mc_1500.webp": 9318,
	"./solucoes/coletor_mc_1500_strong.webp": 6336,
	"./solucoes/coletor_mc_3000_strong.webp": 9859,
	"./solucoes/coletor_pp_flex.webp": 3239,
	"./solucoes/coletor_solar_top_blue.webp": 5165,
	"./solucoes/controladores.png": 4552,
	"./solucoes/dutos.jpg": 6290,
	"./solucoes/dutos.png": 4198,
	"./solucoes/fire.svg": 5769,
	"./solucoes/geradora.png": 4064,
	"./solucoes/gradesVentilacao.png": 7045,
	"./solucoes/grelhas.jpg": 47,
	"./solucoes/grelhas01.jpg": 1330,
	"./solucoes/isolamento.png": 9914,
	"./solucoes/newBombaCalor.png": 5109,
	"./solucoes/novaBombaCalor.webp": 8222,
	"./solucoes/originais/aquecimentoGas.svg": 9821,
	"./solucoes/renovadorAr.jpg": 1410,
	"./solucoes/renovadorAr.png": 5494,
	"./solucoes/reservatorio_grandes_obras.webp": 1014,
	"./solucoes/reservatorio_strong.webp": 593,
	"./solucoes/tubos.jpg": 3664,
	"./solucoes/tubos.png": 4468,
	"./solucoes/valvula.png": 1392,
	"./telefone.svg": 7933,
	"./thiagoAlm.svg": 13,
	"./thiagoAlmeida.svg": 5298,
	"./whatsapp.svg": 3465
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;